export default __webpack_public_path__ + "static/media/pic4.d6e99be6.jpg";